import { render } from "./FullScreenImageModal.vue?vue&type=template&id=6e5a8660&scoped=true&ts=true"
import script from "./FullScreenImageModal.vue?vue&type=script&lang=ts"
export * from "./FullScreenImageModal.vue?vue&type=script&lang=ts"

import "./FullScreenImageModal.vue?vue&type=style&index=0&id=6e5a8660&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5a8660"]])

export default __exports__